// Creates a modal for displaying template descriptions

class WebhookDescModal extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    this.innerHTML = `<style>
                        webhook-desc-modal pre {
                          max-height: 450px;
                          overflow: scroll;
                        }
                      </style>
                      <div class="modal fade bd-example-modal-sm" id="webhookDescModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Integration Template</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-sm-12">
                                  <div id="template-description">
                                  </div>
                                </div>
                              </div>
                              <div class="form-group" style="overflow:auto;">
                                <a id="webhook-modal-cancel" class='btn btn-danger pull-right detail-row-button'>Close</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>`;

    this.querySelector("#webhook-modal-cancel").addEventListener("click", function(e) {
      e.preventDefault();
      this.querySelector(".close").click()
    }.bind(this));
  }
  showTemplate(desc, type) {
    let content = "";
    if(type == 'JSON') {
      try {
        let jsonPretty = JSON.stringify(JSON.parse(desc),null,2);  
        content += `<pre>${jsonPretty}</pre>`;
      } catch(e) {
        content += `<pre>${desc}</pre>`;
      }
    } else {
      content += `<pre>${desc}</pre>`;
    }
    this.querySelector("#template-description").innerHTML = content;

    $("#webhookDescModal").modal("show");
  }
}

customElements.define("webhook-desc-modal", WebhookDescModal)